import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { ContentTypeContainer } from "../components/content-type-container";
import { DebateNoteForm } from "../components/forms/debate-note-form";
import { FaqForm } from "../components/forms/faq";
import { IssueBriefForm } from "../components/forms/issue-brief";
import { MediaLinesForm } from "../components/forms/media-lines-form";
import { MPProfileForm } from "../components/forms/mp-profile";
import { PersonForm } from "../components/forms/person";
import { IAuthContextProps, withAuthContext } from "../components/with-auth-context";
import { AbstractDocumentKind } from "../model/autogen/AbstractDocumentKind";
import { UserLevel } from "../model/autogen/UserLevel";
import { createNewDocument } from "../model/factory";
import { assertNever } from "../utils/never";
import { OpinionEditorialForm } from "../components/forms/opinion-editorial-form"
import { NewQuoteForm } from "components/forms/new-quote-form";
import { AchievementForm } from "components/forms/achievement-form";
import { ResourceForm } from "../components/forms/resource-form";

interface INewContentProps extends RouteComponentProps<any>, IAuthContextProps {

}

class NewContent extends React.Component<INewContentProps & IAuthContextProps, any> {
    private onSaveCompleted = () => {
        this.props.history.goBack();
    }
    private renderForContentType = (ct: AbstractDocumentKind): JSX.Element => {
        const doc = createNewDocument(ct);
        // WTF: Why must I switch on literals and can't use enum values that have same string value???
        // note: this affects the smarts of assertNever at the end
        switch (doc.type) {
            case 'Frequently Asked Questions': //AbstractDocumentKind.FAQ:
                return <FaqForm item={doc} onSaveCompleted={this.onSaveCompleted} />;
            case 'Issue Briefs': // AbstractDocumentKind.IssueBrief:
                return <IssueBriefForm item={doc} onSaveCompleted={this.onSaveCompleted} />;
            case 'MP Profiles': // AbstractDocumentKind.ProfileOfMP:
                return <MPProfileForm item={doc} onSaveCompleted={this.onSaveCompleted} />;
            case 'Debate Notes': // AbstractDocumentKind.DebateNotes:
                return <DebateNoteForm item={doc} onSaveCompleted={this.onSaveCompleted} />;
            case 'Media Lines': // AbstractDocumentKind.MediaLines:
                return <MediaLinesForm item={doc} onSaveCompleted={this.onSaveCompleted} />;
            case 'People': // AbstractDocumentKind.Person:
                return <PersonForm item={doc} onSaveCompleted={this.onSaveCompleted} />;
            case 'Opinion Editorials': // AbstractDocumentKind.OpinionEditorial:
                return <OpinionEditorialForm item={doc} onSaveCompleted=
                {this.onSaveCompleted} />;
            case 'Quotes': //AbstractDocumentKind.Quote:
                return <NewQuoteForm item={doc} onSaveCompleted={this.onSaveCompleted} />;
            case 'Achievements':
                return <AchievementForm item={doc} onSaveCompleted={this.onSaveCompleted} />;
            case 'Resources':
                return <ResourceForm item={doc} onSaveCompleted={this.onSaveCompleted} />;
            }
        assertNever(doc);
    }
    private renderForUnselected = () => {
        return <noscript />;
    }

    public render(): JSX.Element {
        return <ContentTypeContainer renderForSelected={this.renderForContentType} renderForUnselected={this.renderForUnselected} />;
    }
}

export const NewContentPage = withAuthContext(NewContent, UserLevel.External);


// WEBPACK FOOTER //
// ./src/pages/new-content.tsx